export const salutationValueTranslations: Record<string, string> = {
	'Herr': 'Mr',
	'Frau': 'Ms',
	'Mr': 'Herr',
	'Ms': 'Frau',
	'No Salutation': 'Keine Anrede',
	'Keine Anrede': 'No Salutation',
};
